import store from "../store.js";

const globalState = store.getState().globaReducer;

export const verifySchoolCode = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["metaData"];
    const task = globalState["apiTask"]["verifyCode"];

    dispatch({ type: "SHOW_SPPINER" });

    fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      headers: {
        task: task,
        "Content-Type": "application/json",
        Accept: "application/json",
        token: globalState.token,
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        dispatch({ type: "SET_SCHOOL_CODE", data });
        dispatch({ type: "HIDE_SPPINER" });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "HIDE_SPPINER" });
      });
  };
};

export const setAuth = (data, isLogin) => {
  return (dispatch) => {
    dispatch({ type: "SET_USER_DATA", data });
  };
};

export const login = (data) => {
  return (dispatch) => {
    const url = globalState["host"] + globalState["apiEnd"]["profile"];
    const task = globalState["apiTask"]["login"];
    const sc = data.data.sch_code;
    dispatch({ type: "SHOW_SPPINER" });
    fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      headers: {
        task: task,
        "Content-Type": "application/json",
        Accept: "application/json",
        token: globalState.token,
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        if (res.status == "201") {
          res["data"]["sc"] = sc;
          const data = res["data"];
          data["sc"] = sc;
          dispatch({ type: "SET_USER_DATA", data });
        } else {
          dispatch({ type: "SET_SCHOOL_CODE", data: res });
        }
        dispatch({ type: "HIDE_SPPINER" });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "HIDE_SPPINER" });
      });
  };
};
